import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-compliance-certificates',
  templateUrl: './compliance-certificates.component.html',
  styleUrls: ['./compliance-certificates.component.scss']
})
export class ComplianceCertificatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
